import type { FeaturedCardInput } from "@/types/featuredCard";
import { logNavigation, logUserInteraction } from "@/utils/logger";

export default class CastFeaturedCard extends Marko.Component<FeaturedCardInput> {
  handleStorefrontClick() {
    const { firstName, lastName, storefrontUrl } = this.input;

    // Log the storefront click
    logUserInteraction("click", "featured_storefront_card", {
      influencerName: `${firstName} ${lastName}`,
      storefrontUrl: storefrontUrl,
    });

    // Log navigation event
    logNavigation("featured_section", "storefront", "click");
  }
}
